import PropTypes from 'prop-types';
import React from 'react';
import TruncatableText from '../../Elements/TruncatableText/TruncatableText';
import CardHeader from '../CardHeader/CardHeader';

import './AboutCard.scss';

export default class AboutCard extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            isDisplayTextTruncated: true,
        };
        this.truncatedAtIndex = 479;
    }

    static propTypes = {
        /**
         * text that will be displayed as about group
         */
        displayText: PropTypes.string.isRequired,
        /**
         * list of group's locations
         */
        locationList: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.number,
                name: PropTypes.string,
                latitude: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                ]),
                longitude: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.number,
                ]),
            })
        ),
    };

    static defaultProps = {
        displayText: '',
        locationList: [],
    };

    handleShowMoreOrLessClick = () => {
        this.setState({
            isDisplayTextTruncated: !this.state.isDisplayTextTruncated,
        });
    };

    render() {
        const { isDisplayTextTruncated } = this.state;
        const { displayText, locationList } = this.props;
        const shouldShowLocation =
            !!locationList.length &&
            (displayText.length < this.truncatedAtIndex ||
                !isDisplayTextTruncated);

        return (
            <div className="component-Groups-AboutCard">
                <CardHeader>About this group</CardHeader>
                <TruncatableText
                    displayText={displayText}
                    isDisplayTextTruncated={isDisplayTextTruncated}
                    handleShowMoreOrLessClick={this.handleShowMoreOrLessClick}
                    showMoreBtnText={'Read more'}
                    showLessBtnText={null}
                    truncatedAtIndex={this.truncatedAtIndex}
                />
                {shouldShowLocation && (
                    <div className="about-footer">
                        <CardHeader cssClass="footer-header">
                            Group locations
                        </CardHeader>
                        <div className="locations-wrapper">
                            {locationList.map((location, index) => (
                                <span
                                    className="location"
                                    key={`location-${index}`}
                                >
                                    {location.name}
                                </span>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
